import styles from "./BackToMethods.module.css";

export const BackToMethods = () => {
  return (
    <div className={styles.container}>
      <a href="/methods">Change payment method</a>
    </div>
  );
};
